<template>
  <div>
    <b-container class="home-carousel" fluid>
      <VideoBanner
        v-if="!hasPhone"
        :title="bannerData.title"
        :text="bannerData.text"
        :textTwo="bannerData.textTwo"
        :link="loginChange"
      ></VideoBanner>
      <Banners
        :video="true"
        v-if="hasPhone"
        :src="require('@/assets/img/home/video.png')"
        :title="bannerData.title"
        :text="bannerData.text"
        :link="loginChange"
      ></Banners>
    </b-container>
    <!-- <b-container style="padding:0" fluid>
      <div class="home-start wow fadeInDown" ref="scrollHome">
        <div
          class="home-start-content"
          v-for="(item, index) in startData"
          :key="index"
        >
          <img :src="item.img" />
          <h6>{{ item.title }}</h6>
          <p>{{ item.text }}</p>
        </div>
      </div>
    </b-container>-->
    <!-- <b-container>
      <div class="wow fadeInDown home-second home-margin" v-if="hasPhone">
        <Title title="我们的核心是什么" text="WHAT IS OUR CORE"></Title>
        <b-row
          class="core-content"
          v-for="(item, index) in serviceData.data"
          :key="index"
        >
          <b-col cols="12" md="6" class="phone-pad-0">
            <img class="core-img" :src="getImgUrl(item.backgroundUrl)" />
          </b-col>
          <b-col cols="12" md="6" class="phone-pad-0">
            <h6>{{ item.title }}</h6>
            <p>{{ item.desc }}</p>
            <a class="core-a" @click="ToRouter(item.targetEvent)">
              {{ item.targetName }}
              <img src="@/assets/img/home/icon_arrow.png" alt />
            </a>
          </b-col>
        </b-row>
      </div>
      <div class="wow fadeInDown home-second home-margin" v-else>
        <Title title="我们的核心是什么" text="WHAT IS OUR CORE"></Title>
        <b-row
          class="core-content"
          v-for="(item, index) in serviceData.data"
          :key="index"
        >
          <b-col
            cols="12"
            md="6"
            v-if="(index + 1) % 2 != 0"
            class="phone-pad-0"
          >
            <img class="core-img" :src="getImgUrl(item.backgroundUrl)" />
          </b-col>
          <b-col
            cols="12"
            md="6"
            v-if="(index + 1) % 2 != 0"
            class="phone-pad-0"
          >
            <h6>{{ item.title }}</h6>
            <p>{{ item.desc }}</p>
            <a class="core-a" @click="ToRouter(item.targetEvent)">
              {{ item.targetName }}
              <img src="@/assets/img/home/icon_arrow.png" alt />
            </a>
          </b-col>
          <b-col cols="12" md="6" v-if="(index + 1) % 2 == 0">
            <h6>{{ item.title }}</h6>
            <p>{{ item.desc }}</p>
            <a class="core-a" @click="ToRouter(item.targetEvent)">
              {{ item.targetName }}
              <img src="@/assets/img/home/icon_arrow.png" alt />
            </a>
          </b-col>
          <b-col cols="12" md="6" v-if="(index + 1) % 2 == 0">
            <img class="core-img" :src="getImgUrl(item.backgroundUrl)" />
          </b-col>
        </b-row>
      </div>
      <b-modal
        centered
        hide-footer
        v-model="modalApp"
        ref="modalApp"
        class="modal-wx"
      >
        <div class="modal-wx-text" style="text-align:center;">
          <img src="../assets/img/home/wx.png" alt />
          <p>扫描二维码，进入汇才汇能小程序</p>
        </div>
      </b-modal>
      <b-modal
        title="留下您的联系方式，方便我们与您联系"
        centered
        hide-footer
        v-model="modalShow"
        ref="modal"
      >
        <form ref="form" @submit.stop.prevent="handleSubmit" class="home-form">
          <b-form-group
            id="input-group-1"
            label="公司名称"
            label-for="name-input"
            invalid-feedback="请输入公司名称"
            label-cols-sm="3"
            label-cols-lg="3"
          >
            <b-form-input
              id="input-1"
              v-model="form.name"
              required
              size="lg"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-2"
            label="公司邮箱"
            label-for="name-input"
            invalid-feedback="请输入公司邮箱"
            label-cols-sm="3"
            label-cols-lg="3"
          >
            <b-form-input
              id="input-2"
              v-model="form.email"
              required
              size="lg"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-3"
            label="公司联系人"
            label-for="name-input"
            invalid-feedback="请输入公司联系人"
            label-cols-sm="3"
            label-cols-lg="3"
          >
            <b-form-input
              id="input-3"
              v-model="form.people"
              required
              size="lg"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-4"
            label="手机号码"
            label-for="name-input"
            invalid-feedback="请输入手机号码"
            label-cols-sm="3"
            label-cols-lg="3"
          >
            <b-form-input
              id="input-4"
              v-model="form.phone"
              required
              size="lg"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-5"
            label="需求"
            label-for="name-input"
            invalid-feedback="请输入需求"
            label-cols-sm="3"
            label-cols-lg="3"
          >
            <b-form-input
              id="input-5"
              v-model="form.need"
              size="lg"
              required
            ></b-form-input>
          </b-form-group>
          <b-button type="submit" variant="primary">发送</b-button>
        </form>
      </b-modal>
    </b-container>-->
    <!-- <b-container class="home-third wow fadeInDown" fluid>
      <b-container>
        <b-row>
          <b-col cols="12" md="4" class="phone-pad0">
            <Title
              :left="true"
              title="为什么选择我们"
              text="WHY CHOOSE US"
              style="text-align:left;"
            ></Title>
            <p>
              汇才汇能平台有完善的项目库以及人才库，能为人才提供就业、培训的机会，能为企业提供全方位、一站式的财务能力输出服务。
            </p>
          </b-col>
          <b-col cols="12" md="4" class="phone-pad0">
            <Echarts></Echarts>
          </b-col>
          <b-col cols="12" md="4" class="phone-pad0">
            <Echarts :type="echartType"></Echarts>
          </b-col>
        </b-row>
      </b-container>
    </b-container>-->
    <!-- <b-container class="home-fourth home-margin wow fadeInDown">
      <div v-if="projectCategories && projectCategories.length > 0">
        <Title title="特色项目类型" text="PROJECT TYPE"></Title>
        <Carousel
          :carouselData="projectCategories"
          :categoriesImgUr="categoriesImgUr"
          :onChangeImgUr="onChangeImgUr"
        ></Carousel>
      </div>
    </b-container>
    <b-container class="home-five wow fadeInDown">
      <div v-if="projectRecommended.data && projectRecommended.data.length > 0">
        <Title
          title="推荐项目"
          text="RECOMMENDABLE PROJECT
        "
        ></Title>
        <div
          class="projects"
          v-for="(item, index) in projectRecommended.data"
          :key="index"
          style="margin-bottom:0"
        >
          <b-row class="home-five-row">
            <b-col cols="12" md="6">
              <div class="project-content">
                <div class="projects-text">
                  <h6 class="maxLength-text-1">{{ item.name }}</h6>
                  <div class="flex-text">
                    <div class="projects-flex-text">
                      <span>项目类型</span>
                      <Category :categoryId="item.categoryId"></Category>
                    </div>
                    <div class="projects-flex-text">
                      <span>项目预算</span>
                      <p>{{ item.budget }}</p>
                    </div>
                    <div class="projects-flex-text">
                      <span>项目时长</span>
                      <p>{{ item.duration ? item.duration + "天" : "" }}</p>
                    </div>
                  </div>
                </div>
                <div style="display:flex;flex-wrap: wrap">
                  <div class="projects-footer">
                    <i></i>
                    <span>{{ item.customer.name }}</span>
                  </div>
                  <div class="projects-footer">
                    <i></i>
                    <span>
                      {{
                        item.areas
                          ? existData(item.areas[0], "provinceName", "")
                          : ""
                      }}
                      {{
                        item.areas
                          ? existData(item.areas[0], "cityName", " - ")
                          : ""
                      }}
                    </span>
                  </div>
                </div>
              </div>
            </b-col>
            <b-col cols="12" md="6">
              <div class="projects-contexts">
                <p class="maxLength-text-3">{{ onDesc(item.projectDesc) }}</p>
                <a @click="ProjectDetail(item.id)">
                  查看详情
                  <i></i>
                </a>
              </div>
            </b-col>
          </b-row>
        </div>
        <a
          class="core-a"
          @click="
            () => {
              this.$router.push({
                path: `/product`
              });
            }
          "
        >
          更多项目
          <img src="@/assets/img/home/icon_arrow.png" alt />
        </a>
      </div>
    </b-container>-->
    <!-- <b-container
      class="home-six"
      fluid
      v-if="personRecomment && personRecomment.length > 0"
    >
      <b-container>
        <b-row>
          <b-col cols="12" md="4" class="phone-pad-0">
            <Title
              :left="true"
              title="推荐人才"
              text="RECOMMEND TALENTS"
              style="text-align:left;"
            ></Title>
            <p>
              借助先进的平台化管理工具对财经人才
              进行终生赋能，为各个合作伙伴提供高 质量的人才服务
            </p>
            <a
              class="core-a"
              @click="
                () => {
                  this.$router.push({
                    path: `/product`,
                    query: {
                      tab: 1
                    }
                  });
                }
              "
            >
              更多人才
              <img src="@/assets/img/home/icon_arrow.png" alt />
            </a>
          </b-col>
          <b-col cols="12" md="8" class="phone-pad-0">
            <CarouselPerson
              :carouselData="personRecomment"
              :preView="PersonDetail"
            ></CarouselPerson>
          </b-col>
        </b-row>
      </b-container>
    </b-container>-->
    <!-- 特色项目类型 -->
    <b-container class="home-margin home-four wow fadeInDown">
      <Title title="特色项目类型" :left="true"></Title>
      <CarouselPerson
        :carouselData="projectCategories"
        :DataType="3"
        :indicators="false"
        :fade="!hasPhone"
        :controls="controlStart"
      ></CarouselPerson>
    </b-container>
    <!-- 项目流程 -->
    <b-container class="home-margin home-five wow fadeInDown">
      <Title title="项目流程" :left="true"></Title>
      <b-row class="project-process">
        <b-col cols="12" md="3" v-for="(item, index) in process" :key="index">
          <img class="first-img" src="@/assets/img/home/2.png" />
          <div class="circleProgress_wrapper">
            <div class="wrapper right">
              <div class="circleProgress right-circle"></div>
            </div>
            <span>{{ item.num }}</span>
            <div class="wrapper left">
              <div class="circleProgress left-circle"></div>
            </div>
          </div>
          <img :src="item.img" class="second-img" />
        </b-col>
      </b-row>
      <b-row class="project-process-text">
        <b-col
          cols="12"
          md="3"
          v-for="(item, index) in processText"
          :key="index"
        >
          <div>
            <img :src="item.src" />
            <h5>{{ item.title }}</h5>
            <p>{{ item.text }}</p>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <!-- 愿景 -->
    <b-container class="home-margin home-eight wow fadeInDown" fluid>
      <Banners
        :src="require('@/assets/img/aboutUs/banner4.jpg')"
        title="愿景：行业认可的专业人才自由工作平台"
        :titleIcon="true"
        titleSecond="使命：赋能人才，服务企业"
      ></Banners>
    </b-container>
    <b-container class="home-margin home-seven wow fadeInDown">
      <Title title="合作伙伴" :left="true"></Title>
      <CarouselPerson
        :carouselData="partnerData"
        :DataType="DataType"
        :indicators="hasPhone"
      ></CarouselPerson>
    </b-container>
    <!-- 加入我们 -->
    <b-container class="home-nine wow fadeInDown" fluid>
      <div class="join">
        <p>真诚的期待您加入</p>
        <b-button variant="primary" @click="loginChange">
          入汇吧
          <b-icon-arrow-right></b-icon-arrow-right>
        </b-button>
      </div>
    </b-container>
  </div>
</template>

<script>
import WOW from "wowjs";
import Banners from "@/components/banner/Banners.vue";
// import Category from "@/components/category.vue";
import VideoBanner from "@/components/banner/videoBanner.vue";
// import Carousel from "@/components/Carousel.vue";
import CarouselPerson from "@/components/CarouselPerson.vue";
// import Collapse from "@/components/collapse.vue";
// import Echarts from "@/components/echarts.vue";
import publicChange from "@/assets/js/index.js";
import Api from "@/apis";
export default {
  name: "Home",
  data() {
    return {
      hasPhone: false,
      serviceData: [],
      controlStart: true,
      modalApp: false,
      bannerData: {
        title: "专业技能+自由时间 = 执业新未来",
        text: "汇才汇能是为专业人才搭建的自由化工作平台，",
        textTwo: "汇聚相关专业有能之才，实现自由时间价值变现"
      },
      form: {
        name: "",
        email: "",
        people: "",
        phone: "",
        need: ""
      },
      modalShow: false,
      DataType: 1,
      startData: [
        {
          img: require("../assets/img/home/evaluation.png"),
          title: "人才测评",
          text: "图层多维度人才测评体系"
        },
        {
          img: require("../assets/img/home/cultivate.png"),
          title: "培训服务",
          text:
            "线上课件下载，直播培训，线 上答疑 。线下培训课程，实 践营活动， 论坛沙龙 俱乐部等"
        },
        {
          img: require("../assets/img/home/personnel.png"),
          title: "人才服务",
          text: "人才招聘推荐、人才能力构建人才职业规划"
        },
        {
          img: require("../assets/img/home/major.png"),
          title: "专业服务",
          text:
            "审计评估类服务、财税咨询类服务、财务顾问类服务、资本运作类服务等"
        },
        {
          img: require("../assets/img/home/tool.png"),
          title: "工具及其他服务",
          text: "代账工具、答疑工具、 第三方ISV提供的其他服务"
        }
      ],
      coreData: [
        {
          first: {
            img: require("../assets/img/home/home-two1.png"),
            title: "为您提供项目机会",
            text:
              "针对财经人才特有的工作模式和时间安排，定向发送定制化的财税、审计项目工作包，为 在全职工作之余希望利用碎片化时间的专业人员提供能力输出机会，通过平台科学的项目 分解、发包、承接、审核、结算、评价机制提供高频、稳定的财税自由职业机会，使财经 人才在能力提升的同时，赚取“智慧之金”。",
            arrow: "申请项目机会",
            type: 1
          },
          second: {
            img: require("../assets/img/home/home-two2.png"),
            title: "为您提供就业机会",
            text:
              "无论你是财税、会计、审计领域的在校学生、应届毕业生，或是具备经验的专业人士、行业专家，还是企业中的财务、审计中高级管理人员，都可以根据自身需要找到适合的能力提升路径，通过平台的人才画像、能力评价等工具为财经人士职业生涯中的各个重要阶段提供准确、全面、高效的专业赋能，实现职业能力的有效提升。",
            arrow: "申请就业机会",
            type: 2
          }
        },
        {
          first: {
            img: require("../assets/img/home/home-two3.png"),
            title: "为您提供专业培训",
            text:
              "无论你是财税、会计、审计领域的在校学生、应届毕业生，或是具备经验的专业人士、行业专家，还是企业中的财务、审计中高级管理人员，都可以根据自身需要找到适合的能力提升路径，通过平台的人才画像、能力评价等工具为财经人士职业生涯中的各个重要阶段提供准确、全面、高效的专业赋能，实现职业能力的有效提升。",
            arrow: "申请培训机会",
            type: 3
          },
          second: {
            img: require("../assets/img/home/home-two4.png"),
            title: "为您提供财会精英",
            text:
              "平台汇聚了财经领域的大量专业人才，并且通过平台强大的人才画像功能和可靠的能力/技能认证功能已经进行了有效的识别和区分，可以为中介猎头和有财经人才招聘需求的企业人力部门提供更为精准、有效的人才匹配和专业人才储备库。",
            arrow: "联系我们",
            type: 4
          }
        }
      ],
      projectRecommended: [],
      personRecomment: [],
      projectCategories: [],
      categoriesImgUr: "",
      partnerData: [],
      echartType: false,
      featureData: [
        {
          title: "尽职调查资讯",
          src: ""
        },
        {
          title: "IT审计和审讯",
          src: ""
        },
        {
          title: "数字化转型咨询",
          src: ""
        }
      ],
      processText: [
        {
          src: require("@/assets/img/new/home/process/1.png"),
          title: "项目拆解",
          text: "平台专家对项目进行分析拆解项目所需技能"
        },
        {
          src: require("@/assets/img/new/home/process/2.png"),
          title: "人员匹配",
          text: "根据项目所需技能匹配相应人员"
        },
        {
          src: require("@/assets/img/new/home/process/3.png"),
          title: "过程管理",
          text: "对整个项目承做过程进行协调与管理"
        },
        {
          src: require("@/assets/img/new/home/process/4.png"),
          title: "协助交付",
          text: "提交项目成果获得双方反馈"
        }
      ],
      process: [
        {
          num: "01",
          img: require("@/assets/img/new/home/2.png")
        },
        {
          num: "02",
          img: require("@/assets/img/new/home/3.png")
        },
        {
          num: "03",
          img: require("@/assets/img/new/home/4.png")
        },
        {
          num: "04",
          img: require("@/assets/img/new/home/3.png")
        }
      ]
    };
  },
  mounted() {
    // this.getProjectRecomment();
    // this.getPersonRecomment();
    this.getProjectCategories();
    this.getPartners();
    // this.getServer();
    // this.getBanner();
    this.wow();
    if (this._isMobile()) {
      this.hasPhone = true;
    } else {
      this.hasPhone = false;
    }
  },
  components: {
    CarouselPerson,
    VideoBanner,
    Banners
  },
  methods: {
    login() {
      return publicChange.userLogin();
    },
    loginChange() {
      if (this.login()) {
        this.$router.push("/user/talent");
      } else {
        this.$router.push("/login");
      }
    },
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    wow() {
      let wow = new WOW.WOW({
        boxClass: "wow",
        animateClass: "animated",
        offset: 0,
        mobile: true,
        live: true
      });
      wow.init();
    },
    async getProjectRecomment() {
      try {
        const query = {
          pageSize: 4,
          current: 1,
          filters: {
            flagRecommend: 1
          }
        };
        const data = await Api.Project.getProjectRecomment(query);

        this.projectRecommended = data;
      } catch (e) {
        this.$message.error(e, "getProjectRecomment");
      }
    },
    async getServer() {
      try {
        const query = {
          pageSize: 4,
          current: 1
        };
        const data = await Api.Core.getService(query);
        this.serviceData = data;
      } catch (e) {
        this.$message.error(e, "getServer");
      }
    },
    async getPersonRecomment() {
      try {
        const query = {
          current: 1
        };
        const data = await Api.Users.getUserRecomment(query);
        const cateData = data.data;
        let cateArr = [];
        if (cateData && cateData.length > 0) {
          if (this.hasPhone) {
            for (let i = 0; i < cateData.length; i += 3) {
              cateArr.push({ data: cateData.slice(i, i + 3) });
            }
          } else {
            for (let i = 0; i < cateData.length; i += 6) {
              cateArr.push({ data: cateData.slice(i, i + 6) });
            }
          }
        }

        this.personRecomment = cateArr;
      } catch (e) {
        this.$message.error(e, "getPersonRecomment");
      }
    },
    async getProjectCategories() {
      try {
        const query = {
          current: 1,
          filters: {
            flagRecommend: 1
          }
        };
        const data = await Api.Project.getProjectCategories(query);
        const cateData = data.data;
        if (cateData && cateData.length > 0) {
          let cateArr = [];
          if (this.hasPhone) {
            for (let i = 0; i < cateData.length; i += 1) {
              cateArr.push({ data: cateData.slice(i, i + 1) });
            }
          } else {
            for (let i = 0; i < cateData.length; i += 3) {
              cateArr.push({ data: cateData.slice(i, i + 3) });
            }
          }

          this.projectCategories = cateArr;
          this.categoriesImgUr = cateArr[0].data[0].picUrl;
        }
        if (this.hasPhone) {
          if (cateData && cateData.length > 1) {
            this.controlStart = true;
          } else {
            this.controlStart = false;
          }
        } else {
          if (cateData && cateData.length > 3) {
            this.controlStart = true;
          } else {
            this.controlStart = false;
          }
        }
      } catch (e) {
        this.$message.error(e, "getProjectCategories");
      }
    },
    async getPartners() {
      try {
        const query = {
          current: 1
        };
        const data = await Api.Company.getPartner(query);
        const cateData = data.data;
        let cateArr = [];
        if (cateData && cateData.length > 0) {
          if (this.hasPhone) {
            for (let i = 0; i < cateData.length; i += 2) {
              cateArr.push({ data: cateData.slice(i, i + 2) });
            }
          } else {
            for (let i = 0; i < cateData.length; i += 4) {
              cateArr.push({ data: cateData.slice(i, i + 4) });
            }
          }
        }
        this.partnerData = cateArr;
      } catch (e) {
        this.$message.error(e, "getPartners");
      }
    },
    async postInquire(query) {
      try {
        const Post = await Api.Company.getInquire(query);
        if (Post) {
          this.$message.success("发送成功");
          this.modalShow = false;
        }
      } catch (e) {
        this.$message.error(e, "postInquire");
      }
    },
    getBanner() {
      // const banner = JSON.parse(localStorage.getItem("settings"));
      // this.bannerData = banner.homeBanner;
    },
    onDesc(text) {
      return publicChange.disposeHtml(text);
    },
    getImgUrl(img) {
      return publicChange.getStaticUrl(img);
    },
    existData(data, index, text) {
      return publicChange.existData(data, index, text);
    },
    ToRouter(type) {
      if (type == "contact") {
        this.form.name = "";
        this.form.email = "";
        this.form.phone = "";
        this.form.need = "";
        this.form.people = "";
        this.modalShow = true;
      }
      if (type == "app") {
        this.modalApp = true;
      }
    },
    ProjectDetail(id) {
      this.$router.push({
        path: `/product/projectDetails`,
        query: {
          id: id
        }
      });
    },
    PersonDetail(id) {
      this.$router.push({
        path: "/product/personDetails",
        query: {
          id: id
        }
      });
    },
    //跳转特色项目
    toFeature(item) {
      this.$router.push({
        path: "/product/personDetails",
        query: {
          id: item.id
        }
      });
    },
    onChangeImgUr(data, index) {
      if (index == "img") {
        this.categoriesImgUr = data;
      }
      if (index == "details") {
        this.$router.push({
          path: `/project/category/details`,
          query: {
            id: data
          }
        });
      }
    },
    handleSubmit(e) {
      e.preventDefault();
      // Exit when the form isn't valid
      const query = {
        companyName: this.form.name,
        companyEmail: this.form.email,
        tel: this.form.phone,
        content: this.form.need,
        linkman: this.form.people
      };
      this.postInquire(query);
      this.$nextTick(() => {
        this.$bvModal.hide("modal-1");
        for (let i in this.form) {
          this.form[i] = "";
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.home-carousel {
  padding: 0 !important;
}
</style>
